import angular from 'angular';

const componentOptions = {
    bindings: {
        passengers: '=',
        currency: '<',
        passengerIndex: '='
    },
    controllerAs: 'scrollListCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-scroll-list.html';
    }]
};


const componentInfo = {
    module: 'ib-scroll-list-module',
    selector: 'ibScrollList',
    inject: ['$window', 'CurrencyService', '$filter', '$scope', 'AncillariesUtilsService'],
    required: ['']
};

export class ibScrollList implements ng.IController {
    public passengerWrap;
    public newPosition;
    public posContainer;
    public passengersSeat;
    public numColumns;
    public controlBack;
    public activeBtn = false;
    public activeBtnBack = false;
    public isBtnNext = false;
    public isBtnBack = false;
    private containerPassenger = angular.element('.ib-scroll-list__passenger-container');
    public passengers;
    public passengerIndex;
    public currency;

    constructor (
        private $window: ng.IWindowService,
        private CurrencyService: CurrencyService,
        private $filter: ng.IFilterService,
        private $scope: angular.IScope,
        private AncillariesUtilsService: any) {

        this.$scope.$on('nextPassengerScroll', this.nextPassengerScroll);
        this.$scope.$on('reloadInitialStatus', this.activate);

    }

    activate = (): void => {
        this.containerPassenger.css('left', '0px');
        this.newPosition = 0, this.posContainer = 0, this.numColumns = 3, this.controlBack = 0;

        if (this.passengers.length === 2) {
            this.isBtnNext = true;
            this.isBtnBack = true;
            this.numColumns = 2;
        } else if (this.passengers.length <= 1) {
            this.isBtnNext = true;
            this.numColumns = 1;
        }

        if (this.$window.innerWidth <= 767) {
            this.numColumns = 1;
        }
        this.controlArrows();
    };



    /**
     * Click back button
     */
    back = (): void => {
        this.passengerWrap = angular.element('.ib-scroll-list__passenger-wrap');
        this.newPosition += this.passengerWrap.outerWidth();
        this.containerPassenger.animate({ left: this.newPosition + 'px' });
        this.activeBtn = true;
        if (this.AncillariesUtilsService.isResolutionToMobile() && this.AncillariesUtilsService.isTouchDevice()) {
            this.activeBtnBack = true;
            this.$scope.$emit('backPassenger');
        } else {
            this.posContainer--;
            if (this.AncillariesUtilsService.isTouchDevice()) {
                this.$scope.$emit('previousPassenger');
            }
            this.controlArrows();
        }
    };

    /**
     * Click next button
     */
    next = (): void => {
        this.passengerWrap = angular.element('.ib-scroll-list__passenger-wrap');
        this.activeBtn = true;
        if (this.AncillariesUtilsService.isResolutionToMobile() && this.AncillariesUtilsService.isTouchDevice()) {
            this.activeBtnBack = false;
            this.$scope.$emit('nextFlight');
        } else {
            this.posContainer++;
            this.newPosition -= this.passengerWrap.outerWidth();
            this.containerPassenger.animate({ left: this.newPosition + 'px' });
            if (this.AncillariesUtilsService.isTouchDevice()) {
                this.$scope.$emit('nextPassenger');
            }
            this.controlArrows();
        }

    };

    /**
     * Change position of scroll to next passenger
     */
    nextPassengerScroll = (): void => {
        if (
            (this.AncillariesUtilsService.isResolutionToMobile() &&
                this.AncillariesUtilsService.isTouchDevice() &&
                this.passengers.length >= 2
            ) ||
            (this.passengers.length > 2 &&
                this.isBtnNext === false
            )
        ) {
            this.passengerWrap = angular.element('.ib-scroll-list__passenger-wrap');
            if (this.AncillariesUtilsService.isResolutionToMobile() && this.AncillariesUtilsService.isTouchDevice()) {
                this.activeBtn = true;
                if (this.activeBtnBack) {
                    this.posContainer--;
                } else {
                    this.posContainer++;
                    this.newPosition -= this.passengerWrap.outerWidth();
                }
            } else {
                this.activeBtn = false;
                this.newPosition = 0;
                this.newPosition -= this.passengerWrap.outerWidth() * this.passengerIndex;
            }
            this.activeBtnBack = false;
            this.containerPassenger.animate({ left: this.newPosition + 'px' });
            this.controlArrows();
        }
    };


    // Visivilidad de las flechas en el carrousel
    controlArrows = (): void => {
        if (this.activeBtn) {
            if (this.posContainer <= 0) {
                this.isBtnBack = true;
                this.isBtnNext = false;
            } else if (this.posContainer >= this.passengers.length - 3) {
                if (this.AncillariesUtilsService.isResolutionToMobile() && this.AncillariesUtilsService.isTouchDevice()) {
                    if (this.posContainer === this.passengers.length - 1) {
                        this.isBtnNext = true;
                        this.isBtnBack = false;
                    } else {
                        this.isBtnBack = false;
                        this.isBtnNext = false;
                    }
                } else {
                    this.isBtnNext = true;
                    this.isBtnBack = false;
                }
            } else {
                this.isBtnBack = false;
                this.isBtnNext = false;
            }
        } else {
            this.posContainer = this.passengerIndex;
            for (this.passengersSeat = 0; this.passengersSeat < this.passengers.length; this.passengersSeat++) {
                if (this.passengers.length <= 1 || (this.passengers.length <= 3 && !this.AncillariesUtilsService.isResolutionToMobile() && !this.AncillariesUtilsService.isTouchDevice())) {
                    this.isBtnBack = true;
                    this.isBtnNext = true;
                } else {
                    if (this.passengerIndex === 0) {
                        this.isBtnBack = true;
                        this.isBtnNext = false;
                    } else if (this.passengers[this.passengersSeat].id === this.passengers[this.passengers.length - 1].id || this.passengers[this.passengersSeat].id === this.passengers[this.passengers.length - 2].id) {
                        if (this.passengerIndex === this.passengersSeat - 1) {
                            this.isBtnNext = true;
                            this.isBtnBack = false;
                        }
                    } else {
                        this.isBtnBack = false;
                        this.isBtnNext = false;
                    }
                }
            }
        }

    };

    /**
     * Emits event to change passenger
     * @param {*} idPassenger
     */
    changePassenger = (idPassenger: any): void => {
        this.$scope.$emit('selectScrollPassenger', idPassenger);
    };


    /**
     * Filter price
     * @param {*} price
     */
    filterCurrency = (price: any): any => {
        return price > 0 ? this.CurrencyService.formatPrice(this.currency, price, false, false) :this.$filter('translate')('CKIANCSEATS_FREE_PRICE');
    };
    // angular.element($window).bind('resize', () => {
    //     activate();
    // });

}


try {
    const mod = angular.module(componentInfo.module);
    ibScrollList.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibScrollList })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibScrollList.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibScrollList })
    );
}